import React from "react";

const buttonStyle = {
  fontFamily: "Baskerville, serif",
  fontWeight: "bold",
  fontSize: "1.3rem",
  padding: "0.75rem 2.5rem",
  backgroundColor: "#002d21",
  color: "#e7c17f",
  border: "2px solid #000",
  borderRadius: "0.5rem",
  cursor: "pointer",
  boxShadow: "0 4px 0 #000",
  transition: "all 0.1s ease-in-out",
  width: "100%",
  maxWidth: "260px",
  textAlign: "center",
};

const GameOver = ({ onRetry, onShowCorrect }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "radial-gradient(circle at center, #03715f, #034c39)",
        color: "#e7c17f",
        fontFamily: `"Baskerville", "Garamond", "Georgia", serif`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        padding: ".5rem",
        textAlign: "center",
        margin: "0",
      }}
    >
      <h1
        style={{
          fontSize: "3.5rem",
          marginBottom: ".1rem",
          letterSpacing: "1.5px",
        }}
      >
        Game Over
      </h1>

      <p
        style={{
          marginBottom: "2.5rem",
          fontSize: "1.2rem",
          maxWidth: "500px",
        }}
      >
        You ran out of lives.
      </p>

      <button
        onClick={onRetry}
        style={{ ...buttonStyle, marginBottom: "1rem" }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = "translateY(2px)";
          e.currentTarget.style.boxShadow = "0 2px 0 #000";
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 0 #000";

          const sfx2 = new Audio("/sounds/startsfxxx.mp3");
          sfx2.play();
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 0 #000";
        }}
      >
        RETRY
      </button>

      <button
        onClick={onShowCorrect}
        style={buttonStyle}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = "translateY(2px)";
          e.currentTarget.style.boxShadow = "0 2px 0 #000";
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 0 #000";
          const sfx2 = new Audio("/sounds/startsfxxx.mp3");
          sfx2.play();
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 0 #000";
        }}
      >
        SHOW ORDER
      </button>
    </div>
  );
};

export default GameOver;
